export const Api = process.env.REACT_APP_DEVELOPMENT_URL;
// export const Api= 'https://gl-meaningful-killing-oxygen.trycloudflare.com/api/v1';